import Simplemodal from '../../plugins/simplemodal.js';

const fullScreenMenu = new Simplemodal({
  trigger : "data-fullScreenMenu-trigger",
  clickOutSideClose : true,
  // backFixed: false,
})

const targets = document.querySelectorAll(".js-anchor-link");

targets.forEach(target => {
  target.addEventListener("click", ()=> {
    fullScreenMenu.closeAllModal();
  });
});